import apiService from './api';

export interface Tenant {
  id: string;
  name: string;
  description: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTenantDto {
  name: string;
  description: string;
  isActive: boolean;
}

export interface UpdateTenantDto {
  name?: string;
  description?: string;
  isActive?: boolean;
}

class TenantService {
  private baseUrl = '/admin/tenants';

  // Get all tenants with pagination
  public async getTenants(page: number = 0, limit: number = 10, search?: string) {
    return apiService.getPaginated<Tenant>(this.baseUrl, { page, limit, search });
  }

  // Get all tenants (without pagination)
  public async getAllTenants() {
    return apiService.get<Tenant[]>(`${this.baseUrl}/all`);
  }

  // Get tenant by ID
  public async getTenant(id: string) {
    return apiService.get<Tenant>(`${this.baseUrl}/${id}`);
  }

  // Create tenant
  public async createTenant(tenantData: CreateTenantDto) {
    return apiService.post<Tenant>(this.baseUrl, tenantData);
  }

  // Update tenant
  public async updateTenant(id: string, tenantData: UpdateTenantDto) {
    return apiService.patch<Tenant>(`${this.baseUrl}/${id}`, tenantData);
  }

  // Delete tenant
  public async deleteTenant(id: string) {
    return apiService.delete<{ success: boolean }>(`${this.baseUrl}/${id}`);
  }
}

export default new TenantService(); 